var React = require('react');

function Betticket (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M2 2v12h1v-.5s0-.5.5-.5.5.5.5.5v.5h2v-.5s0-.5.5-.5.5.5.5.5v.5h2v-.5s0-.5.5-.5.5.5.5.5v.5h2v-.5s0-.5.5-.5.5.5.5.5v.5h1V2h-1v.5c0 .2 0 .5-.5.5s-.5-.3-.5-.5V2h-2v.5c0 .2 0 .5-.5.5S9 2.7 9 2.5V2H7v.5c0 .2 0 .5-.5.5S6 2.7 6 2.5V2H4v.5c0 .2 0 .5-.5.5S3 2.7 3 2.5V2H2zm3 1.5c.5.5 1 .5 1.5.5s1 0 1.5-.5c.5.5 1 .5 1.5.5s1 0 1.5-.5c.5.5 1 .5 1.5.5h.5v8h-.5c-.5 0-1 0-1.5.5-.5-.5-1-.5-1.5-.5s-1 0-1.5.5c-.5-.5-1-.5-1.5-.5s-1 0-1.5.5c-.5-.5-1-.5-1.5-.5H3V4h.5c.5 0 1 0 1.5-.5zM4 6h8V5H4v1zm0 2h8V7H4v1zm2.5 3H12v-1H6.5v1z"}));
}

Betticket.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = Betticket;

Betticket.default = Betticket;
